import { defineStore } from 'pinia'

export const useStore = defineStore('main', {
  state: () => {
    return {
      status: {
        error: false,
        firstReady: false,
        offline: false,
        ready: false,
        update: false
      },
      config: {
        colors: false,
        fallback: 'zap',
        listSize: 'normal',
        localTime: false,
        showAS: true,
        theme: 'dark'
      },
      schedule: {
        asOnly: [],
        available: [],
        days: {},
        selected: []
      }
    }
  },
  actions: {
    updateStatus (payload) {
      this.status = payload
    },
    updateConfig (payload) {
      this.config = payload
    },
    updateSchedule (payload) {
      this.schedule = payload
    }
  }
})
